// extracted by css-extract-rspack-plugin
export default {"cls1":"QuestionStyles-cls1_jcK","cls2":"QuestionStyles-cls2_Udm QuestionStyles-cls1_jcK"};